module.exports = __webpack_public_path__ + "img/enrolment.17023de9.png";